import { Provider } from '@urbanx/agx.crm.client';
import agentboxLogo from 'assets/images/crm-agentbox.png';
import boxAndDiceLogo from 'assets/images/crm-box-and-dice.png';
import rexLogo from 'assets/images/crm-rex.png';
import vaultLogo from 'assets/images/crm-vault.svg';

const crmProviderLogos = {
  [Provider.Agentbox]: agentboxLogo,
  [Provider.BoxAndDice]: boxAndDiceLogo,
  [Provider.Rex]: rexLogo,
  [Provider.Vault]: vaultLogo,
} satisfies Partial<Record<Provider, string>>;

const CrmIcon = ({ crmProvider }: { crmProvider: Provider }) => {
  const logo = crmProviderLogos[crmProvider];

  if (!logo) {
    return null;
  }

  return (
    <img
      src={logo}
      alt=""
      aria-hidden="true"
      width={40}
      height={40}
      style={{
        backgroundColor: '#F1F5F6',
        borderRadius: 8,
        display: 'block',
        objectFit: 'contain',
        maxWidth: 40,
        maxHeight: 40,
        flexShrink: 0,
      }}
    />
  );
};

export default CrmIcon;
